import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCircleFour = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25}
    height={25}
    viewBox="0 0 496.158 496.158"
    {...props}
  >
    <path
      d="M248.082.003C111.07.003 0 111.061 0 248.085c0 137 111.07 248.07 248.082 248.07 137.006 0 248.076-111.07 248.076-248.07C496.158 111.061 385.088.003 248.082.003"
      style={{
        fill: "#18a09f",
      }}
    />
    <path
      d="M324.983 279.892q-6.812-3.076-18.091-3.076h-6.299V163.437q0-25.488-22.266-25.488-6.886 0-11.792 4.614-4.91 4.615-12.524 14.868l-77.637 103.857a1785 1785 0 0 0-5.42 7.178 112 112 0 0 0-4.248 6.079q-2.053 3.15-3.076 6.006-1.026 2.858-1.025 5.64-.001 10.842 6.958 17.139 6.956 6.3 20.874 6.299h73.535v27.246q0 10.988 5.054 16.626c5.054 5.638 7.787 5.64 13.257 5.64q8.349 0 13.33-5.493 4.98-5.492 4.98-16.772V309.63h8.936q11.13 0 16.699-3.882 5.565-3.88 5.566-12.378.001-10.401-6.811-13.478m-61.01-3.076h-62.988l62.988-85.107z"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);
export default SvgIconCircleFour;
